var $ = require('jQuery');
var Component = require('../../Component');
var template = require('../../../template/notice.html');
var buttonTpl = '<div class="im-notice-button" data-value="${data-value}">${data-text}</div>'
var Notice = function (options) {
  (function (self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
  })(this);
};
Notice.prototype = Object.create(Component.prototype);
Notice.prototype.show = function () {
  Component.prototype.show.call(this);
};
Notice.prototype.hide = function () {
  Component.prototype.hide.call(this);
};
Notice.prototype.setData = function (data) {
  $.extend(this._data, data);
  var html = this.render();
  return html || '';
};
Notice.prototype.render = function () {
  var self = this;
  var element = this.getElement();
  var buttonContainer = element.find('.im-notice-buttons');
  element.find('.im-notice-content').html(this._data.content || '');
  (this._data.buttons || []).forEach(function (button) {
    buttonContainer.append(buttonTpl.replace('${data-text}', button.text).replace('${data-value}', self._options.index + '@' + button.action));
  });
  element.find('.im-notice-close').data('value', self._options.index);
};
Notice.prototype.send = function () {
  var self = this;
  this._options.broadCast && this._options.broadCast('aiSend', {
    text: self._data.content,
    qalog: self._data.qalog,
  });
};
Notice.prototype.copy = function (e) {
  var self = this;
  // var clipboardData;
  // var text = self._data.content.toUpperCase();
  // clipboardData = window.clipboardData;//for IE
  // if(!clipboardData)clipboardData = e.originalEvent.clipboardData;// for safari
  // if(clipboardData){
  //   clipboardData.setData('text/plain', text);
  // }
  // else if(!clipboardData){// for chrome
  //   var transfer = $("<input type='text' id='ai_copy_text'>");
  //   this.getElement().append(transfer);
  //   transfer.val(text);
  //   transfer.focus();
  //   transfer.select();
  //   document.execCommand('Copy', false, null);
  //   $('#ai_copy_text').remove();
  // }
  this._options.broadCast && this._options.broadCast('aiCopy', {
    text: self._data.content,
    qalog: self._data.qalog,
  });
};

module.exports = Notice;
